/*
*
* Script for megamenu overflow handling
*
*/

export const megamenuInit = () => {
    const nav = document.querySelector(".header");

    if (!nav) return;

	const menuMobileBreakpoint = getComputedStyle(document.documentElement)
        .getPropertyValue("--breakpoint-menu-mobile")
        .trim();

	let mediaQuery = window.matchMedia(`(min-width: ${menuMobileBreakpoint})`);

	if (!mediaQuery.matches) return;

	// the services card and the country fly-out are always equal height —
	// whichever is taller sets the height for both.
	nav.querySelectorAll(".header__nav > ul > li.header__megamenu").forEach(li => {
		const panel = li.querySelector(":scope > .sub-menu");
		if (!panel) return;
		const equalise = () => {
			const flyouts = panel.querySelectorAll(":scope > li > .megamenu-submenu-wrap");
			if (!flyouts.length) return;
			// offsetHeight (not scrollHeight): the fly-out is an absolute child of the
			// panel, so scrollHeight would include it and feed back into itself.
			panel.style.minHeight = "";
			flyouts.forEach(f => { f.style.minHeight = ""; });
			let max = panel.offsetHeight;
			flyouts.forEach(f => { max = Math.max(max, f.offsetHeight); });
			panel.style.minHeight = `${max}px`;
			flyouts.forEach(f => { f.style.minHeight = `${max}px`; });
		};
		li.addEventListener("mouseenter", equalise);
		li.addEventListener("focusin", equalise);
		equalise();
	});

	const submenuWrap = nav.querySelectorAll(".megamenu-submenu-wrap");
	if (submenuWrap.length < 1) return;

	submenuWrap.forEach(wrap => {
		const subMenu = wrap.querySelector(" .sub-menu");
		if (!subMenu) return;

		const setOverflowClasses = () => {
			// Check if subMenu overflows submenuWrap
			const wrapRect = wrap.scrollHeight;
			const subMenuRect = subMenu.scrollHeight;
			const bodyContrast = document.body.classList.contains("contrast-mode");

			let wrapSpacing = 81;

			if( bodyContrast ) {
				wrapSpacing = 82;
			}

			if (subMenuRect > (wrapRect - wrapSpacing)) {
				wrap.classList.add("--overflows");
			} else {
				wrap.classList.remove("--overflows");
			}
			if( !wrap.classList.contains("--overflows") ) return;
			if (wrap.scrollTop === 0) {
				wrap.classList.add("--bottom");
				wrap.classList.remove("--top");
			} else if (wrap.scrollTop + wrap.clientHeight < wrap.scrollHeight - 2) {
				wrap.classList.add("--bottom");
				wrap.classList.add("--top");
			} else {
				wrap.classList.add("--top");
				wrap.classList.remove("--bottom");
			}
		}

		wrap.parentElement.addEventListener("mouseenter", setOverflowClasses);
		wrap.parentElement.addEventListener("focusin", setOverflowClasses);

		wrap.addEventListener("scroll", setOverflowClasses, { passive: true });
		setOverflowClasses();
	});

}
